import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden bg-background-50">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20colorful%20vibrant%20webtoon%20comic%20illustration%20background%2C%20soft%20gradient%20warm%20coral%20and%20mint%20green%20blend%2C%20modern%20digital%20art%20with%20subtle%20geometric%20patterns%2C%20Korean%20manhwa%20aesthetic%2C%20clean%20minimal%20design%2C%20bright%20cheerful%20atmosphere%2C%20flowing%20organic%20shapes%2C%20no%20text%20no%20people&width=1600&height=900&seq=hero-bg-main-01&orientation=landscape"
          alt="韩漫漫画网背景"
          title="韩漫漫画网 - 免费韩国漫画在线阅读"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-white leading-tight mb-4">
          探索无限韩漫宇宙
          <br />
          <span className="text-3xl md:text-5xl lg:text-6xl">免费阅读精彩故事每一刻</span>
        </h1>

        <div className="flex justify-center gap-6 md:gap-10 mt-10 mb-12">
          {[
            { seq: 'hero-card-01', color: 'from-rose-400 to-orange-400' },
            { seq: 'hero-card-02', color: 'from-teal-400 to-emerald-400' },
            { seq: 'hero-card-03', color: 'from-amber-400 to-yellow-400' },
          ].map((card, i) => (
            <div
              key={card.seq}
              className="hidden md:block w-32 lg:w-40 h-44 lg:h-56 rounded-xl overflow-hidden transform transition-all duration-500 hover:scale-105 hover:-translate-y-2"
              style={{
                transform: `rotate(${i === 0 ? '-8deg' : i === 1 ? '0deg' : '8deg'}) translateY(${i === 1 ? '-12px' : '0px'})`,
              }}
            >
              <div className={`w-full h-full bg-gradient-to-br ${card.color} flex items-center justify-center`}>
                <div className="text-white/80 text-center p-3">
                  <span className="font-heading text-lg lg:text-xl">
                    {i === 0 ? '恋爱' : i === 1 ? '冒险' : '悬疑'}
                  </span>
                  <p className="text-xs lg:text-sm mt-1 opacity-70">
                    {i === 0 ? '甜宠' : i === 1 ? '热血' : '推理'}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="text-white/80 text-sm md:text-base mb-8 max-w-lg mx-auto leading-relaxed">
          海量韩国漫画 · 每日更新 · 高清画质 · 智能推荐
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/romance"
            className="px-8 py-3.5 bg-primary-500 text-white rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all shadow-lg shadow-primary-500/30"
          >
            开始阅读
          </Link>
          <Link
            to="/category/romance"
            className="px-8 py-3.5 text-white/80 hover:text-white rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-colors border border-white/30 hover:border-white/60"
          >
            探索分类
          </Link>
        </div>
      </div>
    </section>
  );
}